<template>
    <footer>
        <section>
            <div class="container">
                <div class="text-center lg:text-left">
                    <IconStickFigurePhone class="hidden lg:block"/>
                    <div class="grow space-y-6">
                      <div class="max-w-80">
                            <NuxtPicture
                                class="img-center"
                                src="logo-sauerland-spielgeraete.png"
                            />
                        </div>
                      <h3>
                            Kontakt
                      </h3>
                        <p>
                            Telefon: +49 (0) 2955 7606 0<br>
                            Telefax: +49 (0) 2955 7606 221<br>
                            E-Mail: <a href="mailto:info@sauerland-spielgeraete.de">info@sauerland-spielgeraete.de</a>
                        </p>
                        <p>
                            Sauerland Spielgeräte GmbH<br>
                          Kamp 7, 33154 Salzkotten &ndash; Niederntudorf
                        </p>
                      <div class="flex gap-2  justify-center sm:justify-left">
                          <UButton
                                :to="{name: 'contact'}"
                                color="secondary"
                                label="Kontakt"
                                variant="outline"
                          />
                          <UButton
                                :to="{name: 'newsletter'}"
                                color="secondary"
                                label="Newsletter"
                                variant="outline"
                          />
                        </div>
                    </div>
                </div>
                <div>
                    <NuxtPicture
                        class="img-center"
                        src="Sauerland_3D-Planer_MockUp_Handy.png"
                    />
                  <h3 class="text-center">
                    Ihr direkter Weg zum neuen Spielplatz
                    </h3>
                  <div class="gap-2 justify-center flex 2xl:space-y-0 flex-col sm:flex-row">
                      <UButton
                            :to="{name: 'playgroundConfigurator'}"
                            color="secondary"
                            label="Spielplatz-Konfigurator"
                            variant="outline"
                            class="justify-center"
                      />
                      <UButton
                            :to="{name: 'arApp'}"
                            color="secondary"
                            label="3D-Planer App"
                            variant="outline"
                            class="justify-center"
                      />
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div>
                <ul>
                    <li>
                        <NuxtLink :to="{name: 'gtc'}">
                            AGB
                        </NuxtLink>
                    </li>
                    <li>
                        <NuxtLink :to="{name: 'imprint'}">
                            Impressum
                        </NuxtLink>
                    </li>
                    <li>
                        <NuxtLink :to="{name: 'data-protection'}">
                            Datenschutzhinweise
                        </NuxtLink>
                    </li>
                </ul>
            </div>
        </section>
    </footer>
</template>
<script setup lang="ts">
import IconStickFigurePhone from '~/components/Icons/IconStickFigurePhone.vue';
</script>
<style scoped>
</style>
